module.exports = __webpack_public_path__ + "static/media/blazter.d7462533.svg";